import { LoggerService } from '../../shared/sdk/services/custom/logger.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { KanvasUserApi } from './../../shared/sdk/services/custom/KanvasUser';
import { Injectable } from '@angular/core';


@Injectable()
export class AuthGuardService {

  constructor(
    private kanvasUserApi: KanvasUserApi,
    private router: Router,
    private logger: LoggerService
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let curUser;
    try {
      curUser = this.kanvasUserApi.getCachedCurrent();
    } catch (error) {

    }

    if (curUser && curUser.PlayerType) {
      this.logger.info(`This route requires authentication, but the user is not logged in. Redirecting to login page.`);
      this.router.navigate(['/auth/logout']);
      return false;
    }

    if (this.kanvasUserApi.isAuthenticated()) {
      return true;
    } else {
      this.logger.info(`This route requires authentication, but the user is not logged in. Redirecting to login page.`);
      this.router.navigate(['/auth/logout']);
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let curUser;
    try {
      curUser = this.kanvasUserApi.getCachedCurrent();
    } catch (error) {

    }
    if (curUser && curUser.PlayerType) {
      this.logger.info(`This route requires authentication, but the user is not logged in. Redirecting to login page.`);
      this.router.navigate(['/auth/logout']);
      return false;
    }

    if (this.kanvasUserApi.isAuthenticated()) {
      return true;
    } else {
      this.logger.info(`This route requires authentication, but the user is not logged in. Redirecting to login page.`);
      this.router.navigate(['/auth/logout']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core.module/services/authguard.service.ts